"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var account_dev_operations_1 = require("./account-dev-operations");
var account_operations_1 = require("./account-operations");
var RateLimit = /** @class */ (function () {
    function RateLimit(points, last_upgrade) {
        this.points = points;
        this.last_upgrade = last_upgrade;
    }
    RateLimit.prototype.getRequestsLeft = function () {
        return this.points;
    };
    RateLimit.execFreeOperation = function (accountId, blockchain) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, blockchain.transactionBuilder()
                            .add(account_dev_operations_1.freeOp(accountId))
                            .add(account_operations_1.nop())
                            .build([])
                            .post()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    RateLimit.getByAccountRateLimit = function (accountId, blockchain) {
        return __awaiter(this, void 0, void 0, function () {
            var rateInfo;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, blockchain.query('ft3.get_account_rate_limit_last_update', {
                            account_id: accountId,
                        })];
                    case 1:
                        rateInfo = _a.sent();
                        console.log("RATE INFO", rateInfo);
                        if (!rateInfo)
                            return [2 /*return*/, null];
                        return [2 /*return*/, new RateLimit(rateInfo.points, rateInfo.last_update)];
                }
            });
        });
    };
    RateLimit.givePoints = function (accountId, points, blockchain) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, blockchain.transactionBuilder()
                            .add(account_dev_operations_1.givePoints(accountId, points))
                            .add(account_operations_1.nop())
                            .build([])
                            .post()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    RateLimit.getLastTimestamp = function (blockchain) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, blockchain.query('ft3.get_last_timestamp', {})];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    RateLimit.getPointsAvailable = function (points, lastOperation, blockchain) {
        return __awaiter(this, void 0, void 0, function () {
            var maxCount, recoveryTime, lastTimestamp, delta, pointsAvailable;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        maxCount = blockchain.info.rateLimitInfo.maxPoints;
                        recoveryTime = blockchain.info.rateLimitInfo.recoveryTime;
                        return [4 /*yield*/, this.getLastTimestamp(blockchain)];
                    case 1:
                        lastTimestamp = _a.sent();
                        delta = lastTimestamp - lastOperation;
                        pointsAvailable = Math.floor(delta / recoveryTime) + points;
                        if (pointsAvailable > maxCount) {
                            return [2 /*return*/, maxCount];
                        }
                        return [2 /*return*/, pointsAvailable > 0 ? pointsAvailable : 0];
                }
            });
        });
    };
    return RateLimit;
}());
exports.default = RateLimit;
//# sourceMappingURL=rate-limit.js.map